import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import dayjs from "dayjs"
import { Text } from "@/components/ui/baseUi/text"
import { Dot } from "lucide-react"

type ProgramSubscriberDetailsContentStatusProps = {
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsContentStatus({
  subscriberDetails,
  className,
  ...props
}: ProgramSubscriberDetailsContentStatusProps) {
  const subscriptionInfos = subscriberDetails.getProgramSubscriptionStatusInfos()

  return (
    <div className={cn("flex w-full flex-col gap-2", className)} {...props}>
      <div className="flex w-full items-baseline gap-2">
        <Text fontStyle="BS" className="text-textDefault-caption">
          {word("program.subscribers.subscriptionDetails.status.title")}
        </Text>
        <div className="flex grow border-t border-borderDefault" />
      </div>
      <div className="flex flex-row items-center">
        <Dot strokeWidth={10} style={{ color: subscriptionInfos.color }} />
        <div className="flex flex-row items-center gap-1">
          <Text fontStyle="LL" className="text-textDefault-heading">
            {subscriptionInfos.label}
          </Text>
          {subscriptionInfos.information ? (
            <>
              <Text fontStyle="LM" className="text-textDefault-heading">
                ·
              </Text>
              <Text fontStyle="BS" className="text-textDefault-caption">
                {subscriptionInfos.information}
              </Text>
            </>
          ) : null}
        </div>
      </div>
      <div className="flex flex-row items-center gap-2">
        <Text fontStyle="LM" className="text-textDefault-heading">
          {word("program.subscribers.subscriptionDetails.start.label")}
        </Text>
        <Text fontStyle="LM" className="text-textDefault-heading">
          ·
        </Text>
        <Text fontStyle="BS" className="text-textDefault-caption">
          {dayjs(subscriberDetails.subscriptionDate).format("L")}
        </Text>
      </div>
    </div>
  )
}
